import { standardBadgeTheme } from "./standard/standard-theme";
import type { BadgeTheme, BadgeThemeSummary } from "./types";

export const BADGE_THEMES: readonly BadgeTheme[] = [standardBadgeTheme];

export const DEFAULT_BADGE_THEME_ID = standardBadgeTheme.id;

/**
 * Resolve the theme requested by the stations app. Older app builds do not
 * send a theme at all, and a theme can be removed after an app picked it, so
 * a missing or unknown id always falls back to the default.
 */
export const resolveBadgeTheme = (id?: string | null): BadgeTheme =>
  BADGE_THEMES.find((theme) => theme.id === id) ?? BADGE_THEMES[0];

/** What the kiosk publishes to the stations app for its theme selector. */
export const listBadgeThemes = (): BadgeThemeSummary[] =>
  BADGE_THEMES.map(({ id, name, description }) => ({ id, name, description }));
